/** @format */

import { Javascript, ReactLogo, CssLogo, HtmlLogo } from "../../assets";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    categoryName: "React",
    image: ReactLogo,
  },
  {
    categoryName: "Javascript",
    image: Javascript,
  },
  {
    categoryName: "Html",
    image: HtmlLogo,
  },
  {
    categoryName: "Css",
    image: CssLogo,
  },
];
